import moment from 'moment';
import React from 'react';

function FieldIafNumber({ data, value, maxLength }) {
  if (!value) return <>-</>;

  if (data.iaf && data.iaf.number && data.iaf.year) {
    const year = data.iaf.year;
    const number = data.iaf.number;
    return <>{`${number}/${year}`}</>;
  }

  if (
    data.iafs &&
    data.iafs.length > 0 &&
    data.iafs[0].number &&
    data.iafs[0].year
  ) {
    const year = data.iafs[0].year;
    const number = data.iafs[0].number;
    return <>{`${number}/${year}`}</>;
  }

  if (data.invoiceIaf && data.invoiceIaf.length > 0) {
    const date = data.invoiceIaf[0].date;

    const year = moment(date).year();
    const number = data.invoiceIaf[0].number;
    return <>{`${number}/${year}`}</>;
  }

  const year = data.year;
  const number = data.number;

  if (!year || !number) return <>-</>;
  return <>{`${number}/${year}`}</>;
}

export default FieldIafNumber;
